<template>
  <div class="pageBox">
    <div style="margin: 22px 0 0 10px;">
				<el-form :inline="true">
					<el-form-item label="作品类型">
						<el-select v-model="type" clearable placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value"/>
						</el-select>
					</el-form-item>
          <el-form-item>
						<el-button type="primary" @click="search">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
    <div class="tableBox">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
      >
        <el-table-column
          prop="name"
          label="作品名称"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.title | formatting }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="时间" align="center" >
          <template slot-scope="scope">
            {{ scope.row.createTime | formatting }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="状态" align="center" width="100">
          <template slot-scope="scope">
            <div>
              <!-- <span v-if="scope.row.type != 3" class="blueText" @click="edit(scope.row)"> 修改/ </span> -->
              <span class="blueText" @click="edit(scope.row)"> 修改/ </span>
              <span class="orangeText" @click="delData(scope.row)"> 删除 </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="btnBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total,prev, pager, next"
        :page-size="listQuery.pageSize"
        :current-page.sync="listQuery.pageNo"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listQuery: {
        pageNo: 1, // 当前页
        pageSize: 10, // 每页显示数量
      },
      loading: false, // 加载状态
      total: 0, // 总条数
      tableData: [], // 表格数据
      options:[ 
        {value: '', label: '全部'},
        {value: 2, label: '蜘影星'},
        {value: 1, label: '蜘影剧'},
        {value: 0, label: '蜘影新闻'},
        {value: 3, label: '蜘识课程'}
      ],
      type: ''
    };
  },
  filters: {
    //普通格式化
    formatting(value) {
      if (value) {
        return value;
      } else {
        return "暂无";
      }
    },
  },
 
  created() {
    this.getList(); // 获取已发作品列表
  },
  mounted() {},

  methods: {
    search(){
      this.getList();
    },
    //获取列表
    getList() {
        this.loading = true;
        if(this.type !== ''){
          this.listQuery.type = this.type
        } else {
          delete this.listQuery.type
        }
        this.$api.filmsFilmsInfo
          .getMemberFilmList(this.listQuery)
          .then((res) => {
            this.loading = false;
            // console.log("数据列表", res);
            this.tableData = JSON.parse(JSON.stringify(res.result.records));
            this.total = res.result.total;
            
            // 当数据为0条时，重置页码为1
            if (res.result.records.length === 0 && this.listQuery.pageNo > 1) {
              this.listQuery.pageNo = 1;
              // 重新获取第一页数据
              this.getList();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message({
              message: err.message,
              type: "error",
            });
          });
      },
    //分页
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    // 当前页
    handleCurrentChange(val) {
      this.listQuery.pageNo = val;
      this.getList();
    },
    //删除已发作品
    delData(row) {
      this.$confirm("是否确定删除该作品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.filmsFilmsInfo
            .delete({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.$emit("refreshTab");
                this.getList();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //修改
    edit(row) {
      this.$emit("edit", row);
    },
  },
};
</script>

<style  scoped>
.pageBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.tableBox {
  padding: 10px;
}
.blueText {
  color: rgb(100, 188, 216);
  cursor: pointer;
}
.orangeText {
  color: rgb(253, 120, 76);
  cursor: pointer;
}
.btnBox {
  width: 100%;
  padding-right: 20px;
  position: absolute;
  /* bottom: 68px; */
  left: 0;
  height: 70px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>